import {
  Autocomplete,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../Componants/Common/Button";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import toast, { Toaster } from "react-hot-toast";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  fetchModuleList,
  fetchParentModule,
  fetchModule,
  createModule,
  updateModuleStatus,
  updateModule,
  moduleImageUpload
} from "../../../API Service/apiService";
import Paginate from "../../../Componants/Common/Paginate";
import Loader from "../../../Componants/Loader/Loader";
import DynamicTabs from "../../../components/DynamicTabs";
const options = [
  { label: "Option 1" },
  { label: "Option 2" },
  { label: "Option 3" },
];

const cells = ["Module Name", "Parent Module", "Display Order", "Action"];
const rows = [
  {
    moduleName: "Dashboard",
    parentModule: "None",
    displayOrder: 1,
    action: "View",
  },
  {
    moduleName: "User Management",
    parentModule: "Admin",
    displayOrder: 2,
    action: "Edit",
  },
  {
    moduleName: "Reports",
    parentModule: "Dashboard",
    displayOrder: 3,
    action: "View",
  },
  {
    moduleName: "Settings",
    parentModule: "Admin",
    displayOrder: 4,
    action: "Edit",
  },
];

const validationSchema = Yup.object({
  moduleName: Yup.string()
    .required("Module name is required")
    .max(50, "Module name cannot exceed 50 characters")
    .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed"),
  menuDescriptions: Yup.string()
    .required("Description is required")
    .max(100, "Description cannot exceed 100 characters"),
  moduleUrl: Yup.string()
    .required("Module URL is required")
    .max(100, "Module URL cannot exceed 100 characters"),
  displayOrder: Yup.number()
    .required("Display order is required")
    .typeError("Display order must be a number"),
  allowInMenu: Yup.boolean().required("Please select an option"),
  image: Yup.mixed()
    .nullable()
    .test("fileType", "Please select a valid image file", function (value) {
      if (!value) return true;
      if (!(value instanceof File)) return true;
      return value.type.startsWith("image/");
    })
    .test("fileSize", "File size should be less than 5MB", function (value) {
      if (!value) return true;
      if (!(value instanceof File)) return true;
      return value.size <= 5000000;
    }),
  parentModuleId: Yup.string().nullable(),
});

const ModuleMaster = () => {
  const [tableData, setTableData] = useState([]);
  const [parentModuleList, setParentModuleList] = useState([]);
  const [parentModuleSearchList, setParentModuleSearchList] = useState([]);
  const [moduleDropdownList, setModuleDropdownList] = useState([]);
  const [searchParams, setSearchParams] = useState({
    parentModuleId: "",
    moduleId: "",
    page: 1,
    limit: 10,
  });
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dataSize, setDataSize] = useState(10);
  const [selectedModuleName, setSelectedModuleName] = useState(null);
  const [selectedParentModule, setSelectedParentModule] = useState(null);
  const fileInputRef = useRef(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [currentModuleId, setCurrentModuleId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const topRef = useRef(null);

  const handlePageChange = (newPage) => {
    setPage(newPage);

    setSearchParams((prevParams) => ({
      ...prevParams,
      page: newPage.toString(),
    }));
  };

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      formik.setFieldValue("image", file);
      formik.setFieldTouched("image", true, false);
      console.log("Image file selected:", file);
    }
  };

  const handleReset = () => {
    formik.resetForm();
    setIsUpdateMode(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const formik = useFormik({
    initialValues: {
      moduleName: "",
      menuDescriptions: "",
      displayOrder: "",
      allowInMenu: "",
      moduleUrl: "",
      image: null,
      parentModuleId: "",
      cardTitle: "",
      isUpdateMode: false,
    },
    validationSchema,
    onSubmit: async (values) => {
      console.log("valuesssssssss", values);
      console.log("isUpdateMode", isUpdateMode);
      setIsLoading(true);
      if (isUpdateMode) {
        await handleUpdateModule(values);
      } else {
        try {
          let iconPath = '';
          
          // First upload the image if it exists
          if (values.image instanceof File) {
            const imageFormData = new FormData();
            imageFormData.append('image', values.image);
            
            const imageResponse = await moduleImageUpload(imageFormData);
            if (imageResponse.data.status === 'success') {
              iconPath = imageResponse.data.data.fullPath; // Adjust this based on actual response structure
            } else {
              throw new Error('Image upload failed');
            }
          }

          const body = {
            moduleName: values.moduleName,
            menuDescriptions: values.menuDescriptions,
            moduleUrl: values.moduleUrl,
            displayOrder: values.displayOrder,
            allowInMenu: values.allowInMenu.toString(),
            parentModuleId: values.parentModuleId || null,
            cardTitle: values.cardTitle || "",
          };
          if (iconPath) {
            body.imagePath = iconPath;
          }

          const response = await createModule(body);
          console.log("response", response);
          if (response.status === "success") {
            toast.success(response.message || response.data);
            handleReset();
            getModuleList();
          }
        } catch (error) {
          console.error("Error creating module:", error);
          toast.error(error.response?.data?.message || "Error creating module");
        } finally {
          setIsLoading(false);
        }
      }
    },
  });

  // get module list
  const getModuleList = async (params = searchParams) => {
    try {
      setIsLoading(true);
      const response = await fetchModuleList(params);
      if (response.status == "success") {
        setTableData(response.data.modules);
        setTotalRecords(response.data.pagination.totalCount);
        setPage(response.data.pagination.currentPage);
        setDataSize(response.data.pagination.limit);
      } else if (response.status == "error") {
        setTableData([]);
        setTotalRecords(0);
        setPage(1);
        setDataSize(10);
      }
    } catch (error) {
      setTableData([]);
      console.error("Error fetching module list:", error);
      toast.error("Error fetching module list");
    } finally {
      setIsLoading(false);
    }
  };
  // get parent module list
  const getParentModuleList = async () => {
    try {
      setIsLoading(true);
      const response = await fetchParentModule();

      if (response.status == "success") {
        console.log(response.data);
        setParentModuleList(response.data);
      }
    } catch (error) {
      console.error("Error fetching parent module list:", error);
      toast.error("Error fetching parent module list");
    } finally {
      setIsLoading(false);
    }
  };
  const getParentModuleSearchList = async () => {
    try {
      setIsLoading(true);
      const response = await fetchParentModule();

      if (response.status == "success") {
        console.log(response.data);
        setParentModuleSearchList(response.data);
      }
    } catch (error) {
      console.error("Error fetching parent module list:", error);
      toast.error("Error fetching parent module list");
    } finally {
      setIsLoading(false);
    }
  };

  const getModuleDropdown = async () => {
    try {
      setIsLoading(true);
      const response = await fetchModule();
      if (response.status == "success") {
        console.log(response.data);
        setModuleDropdownList(response.data);
      }
    } catch (error) {
      console.error("Error fetching module dropdown:", error);
      toast.error("Error fetching module dropdown");
    } finally {
      setIsLoading(false);
    }
  };

  const handleStatus = async (id) => {
    console.log("Toggling status for module ID:", id);
    try {
      setIsLoading(true);
      const params = { moduleId: id };
      const response = await updateModuleStatus(params);
      console.log("API response:", response);
      if (response.success == true) {
        toast.success(response.message);
        getModuleList();
      } else {
        console.error("API error response:", response);
        toast.error("Failed to update module status");
      }
    } catch (error) {
      console.error("Error updating module status:", error);
      toast.error("Error updating module status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (module) => {
    console.log("Editing module:", module);
    // Scroll to top first
    topRef.current?.scrollIntoView({ behavior: "smooth" });

    formik.setValues({
      moduleName: module.moduleName,
      menuDescriptions: module.menuDescriptions,
      displayOrder: module.displayOrder,
      allowInMenu: module.allowInMenu,
      moduleUrl: module.moduleUrl,
      image: module.icon ? module.icon : null, // Use existing icon
      parentModuleId: module.parentModuleId || "",
      cardTitle: module.cardTitle || "",
    });
    setCurrentModuleId(module._id);
    setIsUpdateMode(true);
  };

  const handleUpdateModule = async (values) => {
    console.log("Updating moduleeeee:", values);
    try {
      setIsLoading(true);
      let iconPath = '';
      if (values.image instanceof File) {
        const imageFormData = new FormData();
        imageFormData.append('image', values.image);
        
        const imageResponse = await moduleImageUpload(imageFormData);
        if (imageResponse.data.status === 'success') {
          iconPath = imageResponse.data.data.fullPath;
        } else {
          throw new Error('Image upload failed');
        }
      }
      
      const body = {
        moduleName: values.moduleName,
        menuDescriptions: values.menuDescriptions,
        moduleUrl: values.moduleUrl,
        displayOrder: values.displayOrder,
        allowInMenu: values.allowInMenu.toString(),
        parentModuleId: values.parentModuleId || null,
        cardTitle: values.cardTitle || "",
      };

      if (iconPath) {
        body.imagePath = iconPath;
      } else if (typeof values.image === 'string') {
        body.imagePath = values.image; // Use existing image path if no new file is uploaded
      }


      const response = await updateModule({ id: currentModuleId }, body);
      if (response.success === true) {
        toast.success(response.message || "Module updated successfully");
        handleReset();
        setIsUpdateMode(false);
        setCurrentModuleId(null);
        getModuleList();
      }
    } catch (error) {
      console.error("Error updating module:", error);
      toast.error(error.response?.data?.message || "Error updating module");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getModuleList();
  }, [page]);

  useEffect(() => {
    getModuleList();
    getParentModuleList();
    getModuleDropdown();
    getParentModuleSearchList();
  }, []);

  const handleSearch = () => {
    console.log(`hi i am clicked`);
    setPage(1);
    const updatedParams = {
      ...searchParams,

      page: 1,
    };
    setSearchParams(updatedParams);
    getModuleList(updatedParams);
  };

  const handleCancel = () => {
    setSelectedModuleName(null);
    setSelectedParentModule(null);
    const updatedParams = {
      parentModuleId: "",
      moduleId: "",
      page: 1,
      limit: 10,
    };
    setSearchParams(updatedParams);
    getModuleList(updatedParams);
  };

  // Check if Setting is the selected parent module
  const isSettingParent = parentModuleList.find(
    (item) => item._id === formik.values.parentModuleId
  )?.moduleUrl?.toLowerCase() === "/setting";
  console.log("isSettingParent", isSettingParent);
  return (
    <Grid ref={topRef}>
      <Toaster />
      {isLoading && <Loader />}
       <HeaderNavigation value={"Module"} />
      <DynamicTabs />
      <Grid
        container
        gap={4}
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid container spacing={3} sx={{ maxWidth: "1200px" }}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              id="moduleName"
              name="moduleName"
              label="Module Name"
              variant="standard"
              value={formik.values.moduleName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.moduleName && Boolean(formik.errors.moduleName)
              }
              helperText={formik.touched.moduleName && formik.errors.moduleName}
              sx={{ maxWidth: "250px" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              id="menuDescriptions"
              name="menuDescriptions"
              label="Description"
              variant="standard"
              value={formik.values.menuDescriptions}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.menuDescriptions &&
                Boolean(formik.errors.menuDescriptions)
              }
              helperText={
                formik.touched.menuDescriptions &&
                formik.errors.menuDescriptions
              }
              sx={{ maxWidth: "250px" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              id="moduleUrl"
              name="moduleUrl"
              label="Module URL"
              variant="standard"
              value={formik.values.moduleUrl}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.moduleUrl && Boolean(formik.errors.moduleUrl)
              }
              helperText={formik.touched.moduleUrl && formik.errors.moduleUrl}
              sx={{ maxWidth: "250px" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              id="displayOrder"
              name="displayOrder"
              label="Display Order"
              variant="standard"
              value={formik.values.displayOrder}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.displayOrder &&
                Boolean(formik.errors.displayOrder)
              }
              helperText={
                formik.touched.displayOrder && formik.errors.displayOrder
              }
              sx={{ maxWidth: "250px" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
              id="parentModuleId"
              fullWidth
              options={parentModuleList}
              getOptionLabel={(option) => option?.moduleName || ""}
              value={
                parentModuleList.find(
                  (item) => item._id === formik.values.parentModuleId
                ) || null
              }
              onChange={(_, value) => {
                formik.setFieldValue("parentModuleId", value?._id || "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Parent Module"
                  variant="standard"
                  error={
                    formik.touched.parentModuleId &&
                    Boolean(formik.errors.parentModuleId)
                  }
                  helperText={
                    formik.touched.parentModuleId &&
                    formik.errors.parentModuleId
                  }
                  sx={{ maxWidth: "250px" }}
                />
              )}
            />
          </Grid>
          {isSettingParent && (
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                id="cardTitle"
                name="cardTitle"
                label="Add Card Title"
                variant="standard"
                value={formik.values.cardTitle}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.cardTitle && Boolean(formik.errors.cardTitle)
                }
                helperText={formik.touched.cardTitle && formik.errors.cardTitle}
                sx={{ maxWidth: "250px" }}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl
              variant="standard"
              fullWidth
              error={
                formik.touched.allowInMenu && Boolean(formik.errors.allowInMenu)
              }
              sx={{ maxWidth: "250px" }}
            >
              <InputLabel>Allow in Menu</InputLabel>
              <Select
                id="allowInMenu"
                name="allowInMenu"
                value={formik.values.allowInMenu}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
              {formik.touched.allowInMenu && formik.errors.allowInMenu && (
                <FormHelperText>{formik.errors.allowInMenu}</FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl
              error={formik.touched.image && Boolean(formik.errors.image)}
              sx={{ width: "100%", maxWidth: "250px" }}
            >
              <input
                ref={fileInputRef}
                type="file"
                id="image"
                name="image"
                accept="image/*"
                onChange={handleFileChange}
                onBlur={formik.handleBlur}
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              />
              {formik.touched.image && formik.errors.image && (
                <FormHelperText error>{formik.errors.image}</FormHelperText>
              )}
            </FormControl>
            {formik.touched.image && formik.errors.image && (
              <div
                style={{
                  color: "#d32f2f",
                  fontSize: "0.75rem",
                  marginTop: "3px",
                }}
              >
                {formik.errors.image}
              </div>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ marginTop: "20px", maxWidth: "1200px" }}
        >
          <Grid item>
            <CommonButton
              name={isUpdateMode ? "Update" : "Create"}
              handleOnClick={formik.handleSubmit}
            />
          </Grid>
          <Grid item>
            <CommonButton name="Cancel" handleOnClick={handleReset} />
          </Grid>
        </Grid>
      </Grid>

      {/* Search section */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          margin: "10px",
          padding: "20px",
          borderRadius: "5px",
        }}
      >
        <Grid
          container
          spacing={3}
          alignItems="center"
          sx={{ maxWidth: "1200px" }}
        >
          <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
              disableCloseOnSelect
              options={moduleDropdownList}
              getOptionLabel={(option) => option.moduleName}
              value={
                moduleDropdownList.find(
                  (item) => item._id === searchParams.moduleId
                ) || null
              }
              onChange={(_, value) => {
                setSearchParams((prevParams) => ({
                  ...prevParams,
                  moduleId: value?._id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Module Name"
                  variant="standard"
                  fullWidth
                  sx={{ maxWidth: "250px" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
              disableCloseOnSelect
              options={parentModuleList}
              getOptionLabel={(option) => option.moduleName}
              value={
                parentModuleList.find(
                  (item) => item._id === searchParams.parentModuleId
                ) || null
              }
              onChange={(_, value) => {
                setSearchParams((prevParams) => ({
                  ...prevParams,
                  parentModuleId: value?._id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Parent Module"
                  variant="standard"
                  fullWidth
                  sx={{ maxWidth: "250px" }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <CommonButton name="Search" handleOnClick={handleSearch} />
          </Grid>
          <Grid item>
            <CommonButton name="Cancel" handleOnClick={handleCancel} />
          </Grid>
        </Grid>

        {/* Table section */}
        <Grid container sx={{ marginTop: "20px" }}>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{ color: "white", textAlign: "center" }}
                    >
                      {cell}
                    </TableCell> // Adding a key prop
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length == 0 ? (
                  <TableRow>
                    <TableCell colSpan={cells.length} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {row.moduleName || "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {row.parentModuleName || "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {row.displayOrder || "NA"}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                        }}
                      >
                        <IconButton
                          // onClick={() => handleStatus(index)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={row.status == true ? activeIcon : inactiveIcon}
                            onClick={() => handleStatus(row._id)}
                            alt="active"
                            height={"20px"}
                            width={"20px"}
                          />
                        </IconButton>
                        <IconButton
                          onClick={() => handleEdit(row)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            height={"20px"}
                            width={"20px"}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Grid container>
        <Paginate
          page={page}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          dataSize={dataSize}
        />
      </Grid>
    </Grid>
  );
};

export default ModuleMaster;
